module.exports = __webpack_public_path__ + "static/media/Culvert_On.2e737251.png";